import ResolvedAnnotationsHandler from "./ResolvedAnnotationsHandler";

const noOpenAnnotations = () => !$(".annotation-container.is-open").length;

const KeydownListener = () => {
  // Move left and right through pagination
  // with arrow keys
  $(document).on("keydown", (e) => {
    switch (e.which) {
      // left
      case 37:
        if (noOpenAnnotations()) {
          $("a[rel=prev]").children()[0].click();
        }
        break;
      // right
      case 39:
        if (noOpenAnnotations()) {
          $("a[rel=next]").children()[0].click();
        }
        break;
      default:
    }
  });
};

const SetupResolvedHandler = (annotations, currentAnno) => {
  const currAnno = $.grep(annotations, anno => anno.id === currentAnno)[0] || {};
  // has to come after annotations init
  new ResolvedAnnotationsHandler({ resolved: currAnno.resolved });
};

export { KeydownListener, SetupResolvedHandler };
